// modules/SignatureField.jsx
import React from "react";
import { Box } from "@mui/material";
import SignatureComponent from "../components/SignatureComponent";

const SignatureField = ({
  module,
  fieldKey,
  signatureData,
  isEditable,
  onSignatureChange,
  onRemove,
}) => {
  return (
    <Box marginY={2}>
      <SignatureComponent
        label={module.label || "Signature"}
        signatureData={signatureData}
        onSignatureChange={onSignatureChange}
        onRemove={onRemove}
        isEditable={isEditable}
      />
    </Box>
  );
};

export default SignatureField;
